/* eslint-disable no-shadow */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CRMRetargetingModal from "../../components/Advertisers/CRMRetargetingModal";
import CampaignCreationSlideContainer from "../../components/CampaignCreation/CampaignCreationSlideContainer";
import EmailsDashboard from "./EmailsDashboard";
import HubSpotDataUploader from "../../components/CampaignCreation/HubSpotDataUploader";
import { EmailRegExp } from "../../constants/regExp";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";
import { SelectOptionType } from "../../components/elements/Select/Select";
import { emailSampleLink } from "../../constants/sampleLinks";
import { errorToaster } from "../../helpers/toasters";
import {
  getFoundEmailsInfo,
  getHubSpotLists,
  setCampaignToCreateSelectedAdvertiser,
  setFoundEmailsInfo,
} from "../../redux/reducers/campaignToCreate";
import { processEmails } from "../../utils/processEmails";

const CRMRetargetinSegmentsPage = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
}: {
  isAttemptingToGoNext?: boolean;
  setIsAttemptingToGoNext?: (isAttemptingToGoNext: boolean) => void;
  handleNext?: () => void;
}) => {
  const dispatch = useDispatch();

  const [selectedBgAdvertiserId, setSelectedBgAdvertiserId] = useState("");
  const [selectedList, setSelectedList] = useState<any[]>([]);
  const [areEmailsLoading, setAreEmailsLoading] = useState<boolean>(false);

  const advertisers = useSelector((state: ReduxApplicationState) => state.agency.advertisers);
  const foundEmailsInfo = useSelector((state: ReduxApplicationState) => state.campaignToCreate.foundEmailsInfo);
  const hubSpotLists = useSelector((state: ReduxApplicationState) => state.campaignToCreate.hubSpotLists);
  const selectedAdvertiser = useSelector((state: ReduxApplicationState) => state.campaignToCreate.selectedAdvertiser);
  const apiError = useSelector((state: ReduxApplicationState) => state.apiError);
  const isHubSpotListsPending = useSelector((state: ReduxApplicationState) => state.campaignToCreate.isPending);

  const options: SelectOptionType[] = hubSpotLists?.lists?.map((list) => ({
    label: list.name,
    value: list.listId.toString(),
    key: list.listId,
  }))!;

  const processValidatedData = (uploadedEmails: string[], fileName: string) => {
    setAreEmailsLoading(true);
    const processedData = processEmails(uploadedEmails, fileName);
    dispatch(setFoundEmailsInfo(processedData));
    setAreEmailsLoading(false);
  };

  const handleListChange = (e: any) => {
    setSelectedList(e.target.value);
  };

  const getDataByCategory = async () => {
    try {
      if (selectedList.length > 0) {
        setAreEmailsLoading(true);
        dispatch(getFoundEmailsInfo(selectedList, setAreEmailsLoading));
      } else {
        errorToaster("Select a List to get Contacts.", 5000);
      }
    } catch (error) {
      console.log("Error in handleGetEmailsInfo: ", error);
      errorToaster(error, 5000);
    }
  };

  useEffect(() => {
    if (apiError.apiError) errorToaster(apiError.apiError, 5000);
  }, [apiError]);

  // Get Lists
  useEffect(() => {
    if (selectedAdvertiser?.hubspot_authed) {
      dispatch(getHubSpotLists("contact_lists"));
    }
  }, [dispatch, selectedAdvertiser]);

  useEffect(() => {
    if (isAttemptingToGoNext && setIsAttemptingToGoNext && handleNext) {
      if (foundEmailsInfo?.emailsToHash.length !== 0) {
        handleNext();
        setIsAttemptingToGoNext(false);
      } else {
        errorToaster('Please, choose a HubSpot List and select "Get Emails".', 5000);
        setIsAttemptingToGoNext(false);
      }
    }
  }, [dispatch, handleNext, isAttemptingToGoNext, setIsAttemptingToGoNext, foundEmailsInfo]);

  // Set Selected Advertiser in store by selectedBgAdvertiserId
  useEffect(() => {
    if (!selectedBgAdvertiserId && setIsAttemptingToGoNext) return;

    const findedAdvertiser = advertisers.find(
      (advertiser) => advertiser.brandgenAdvertiserId === selectedBgAdvertiserId,
    );

    if (findedAdvertiser) dispatch(setCampaignToCreateSelectedAdvertiser(findedAdvertiser));
  }, [advertisers, dispatch, selectedBgAdvertiserId, setIsAttemptingToGoNext]);

  const mainContent = () => (
    <>
      <HubSpotDataUploader
        selectedBgAdvertiserId={selectedBgAdvertiserId}
        setSelectedBgAdvertiserId={setSelectedBgAdvertiserId}
        processValidatedData={processValidatedData}
        dataName="Emails"
        regex={EmailRegExp}
        isStepInCampaignCreation={!!setIsAttemptingToGoNext}
        hubSpotSelectorOptions={options}
        getDataFromHubSpot={getDataByCategory}
        handleOptionChange={handleListChange}
        hubSpotSelectorLabel="HubSpot Segments"
        hubSpotSelectorButtonLabel="Get Emails"
        hubSpotSelectorValue={selectedList}
        areDataFromHubSpotIsLoading={areEmailsLoading}
        sampleLink={emailSampleLink}
      />

      {!isHubSpotListsPending && (
        <EmailsDashboard emailsToHash={foundEmailsInfo?.emailsToHash ?? []} areEmailsLoading={areEmailsLoading} />
      )}
    </>
  );

  return (
    <div
      style={{
        padding: !setIsAttemptingToGoNext ? "4rem" : 0,
      }}
    >
      {setIsAttemptingToGoNext ? (
        <CampaignCreationSlideContainer heading={selectedAdvertiser?.hubspot_authed ? "Select HubSpot Segments" : ""}>
          {mainContent()}
        </CampaignCreationSlideContainer>
      ) : (
        <>
          {mainContent()}
          <CRMRetargetingModal />
        </>
      )}
    </div>
  );
};

export default CRMRetargetinSegmentsPage;
